<div class="flex flex-col h-full items-center justify-center">
  <div class="flex flex-col items-center flex-shrink-0 w-full">
      <img class="w-auto h-48 lg:h-72 m-auto mt-20 mb-20" src="assets/images/logos/alphastar-full%20logo-mint.png">
      <div class="relative flex-shrink-0 w-460 max-w-9/10 card">
          <app-signup-form></app-signup-form>
      </div>
      <app-copyright></app-copyright>
  </div>
</div>
